export const vapid_public_key = `BGoIRG83fTh6zAjUHpNquPgDu9e5edqn62Xa2lfo-NszVDUWCTuIqupK6FCA1qXkPb3L2lFLFE_MZnM5yuVmAc8`